import { EmojiLikeableEntity, likeKey } from "@/mk2/containers/Like/Like.schemas";

export interface EmojiLikeableEntitiesState {
    [entitySlashId: string]: EmojiLikeableEntity;
}

export const getUserReaction = (
    state: EmojiLikeableEntitiesState,
    entity: string,
    id: number,
): string | null => {
    const key = likeKey(entity, id);
    return state && state[key] ? state[key].userReaction : null;
};

export const getReactionsBreakdown = (
    state: EmojiLikeableEntitiesState,
    entity: string,
    id: number,
): Record<string, number> => {
    const key = likeKey(entity, id);
    return state && state[key] ? state[key].reactionsBreakdown || {} : {};
};

export const getReactionsTotalCount = (
    state: EmojiLikeableEntitiesState,
    entity: string,
    id: number,
): number => {
    const key = likeKey(entity, id);
    return state && state[key] ? state[key].reactionsTotalCount || 0 : 0;
};
